exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".contact-success-text-block{padding:10px 10px 100px;text-align:center;font-size:1.125rem;line-height:1.563rem;font-weight:400}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/ContactUs/ContactSuccess.scss
 ** module id = 1191
 ** module chunks = 0
 **/